import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Card,
  Form,
  Alert,
  Spinner,
  InputGroup,
  DropdownDivider,
} from "react-bootstrap";

import GeneralInformation from "./GeneralInformationForm";
import Stepper from "../../components/Stepper";
import ContactDetailsForm from "./ContactDetailsForm";
import PaymentAndShippingForm from "./PaymentAndShippingForm";
import OtherDetailsForm from "./OtherDetailsForm";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import {
  IconArrowNarrowLeftDashed,
  IconArrowNarrowRightDashed,
  IconCloudUpload,
} from "@tabler/icons-react";
import "./NewQuote.css";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { toast } from "react-toastify";
import SalesLead from "./SalesLead";
import Attachment from "./Attachment";
import { format } from "date-fns";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import { isValidPhoneNumber } from "react-phone-number-input";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import FinanceTab from "./FinanceTab";
import useIdleLogout from "../../hooks/useIdleLogout";
import { trimTrailingZeros } from "../../utils/_helpers";
import { usePostHog } from "@posthog/react";
import GsaPdfModal from "./GSAPDF/GsaPdfModal";

const PORT = process.env.REACT_APP_BASE_URL;

const generateUniqueId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  let result = "";
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  const timestamp = Date.now().toString();
  const uniqueId = result + timestamp.slice(-4);
  return uniqueId;
};

function NewQuote() {
  const location = useLocation();
  const { selectedCopy, rfqCopy } = location.state || {};
  const [initialVal, setInitialVal] = useState(1);
  const [serverErr, setServerErr] = useState([]);
  const [show, setShow] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [rfqDataFetched, setRfqDataFetched] = useState(false);
  const [rfqDataFetchedcopy, setRfqDataFetchedcopy] = useState(false);
  const [formId, setFormId] = useState(null);
  const [apiVendor, setApiVendor] = useState([]);
  const [isOrderMade, setisOrderMade] = useState("");

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    message: "",
    btntext: "",
    title: "",
    newbtn: "",
  });

  const [isPDFOpen, setIsPDFOpen] = useState({
    show: false,
  });

  const [rfqstatus, setRfqStatus] = useState();

  const handleStatusChange = (event) => {
    setRfqStatus(event.target.value);
  };

  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const allowedRoles = ["super-admin"];
  const isSuperAdmin = user?.roles?.some((role) => allowedRoles.includes(role));
  const restrictedStatuses = ["WON", "LOST", "CANCELLED"];
  const posthog = usePostHog();

  const canShowButtons =
    !restrictedStatuses.includes(rfqstatus) || isSuperAdmin;

  useEffect(() => {
    const rfqIdDuplication = location.state?.rfqId;
    if (rfqIdDuplication) {
      // setValue("orderId", orderIdDuplication || "");
      fetchSingleRfq({ rfq_id: rfqIdDuplication }, onSingleCopySuccess);
    }
  }, [location.state]);

  const onSingleCopySuccess = (rfq) => {
    console.log("abcd", rfq);
    if (rfq?.data) {
      if (rfq?.data?.attachment_id) {
        setFormId(rfq?.data?.attachment_id);
      }
      setValue(
        "opportunityType",
        rfq?.data?.opportunity_type ? rfq?.data?.opportunity_type : "",
      );
      setValue(
        "opportunityName",
        rfq?.data?.opportunity_name ? rfq?.data?.opportunity_name : "",
      );
      // setValue("rfqId", rfq?.data?.rfq_id ? rfq?.data?.rfq_id : null);
      setValue(
        "contractVehicle",
        rfq?.data?.contract_type_id ? rfq?.data?.contract_type_id : null,
      );
      setValue(
        "organization_name",
        rfq?.data?.organization_name ? rfq?.data?.organization_name : "",
      );
      setValue("Opportunity_Description", rfq?.data?.brief);
      setValue("vehicleId", rfq?.data?.ContractType?.id);
      setValue(
        "contractVehicletype",
        rfq?.data?.ContractType?.contract_vehicle_type
          ? rfq?.data?.ContractType?.contract_vehicle_type
          : null,
      );
      setValue("order_Payment_Type", rfq?.data?.order_payment_type);
      setValue("ordertype", rfq?.data?.order_type ?? "DS");
      setValue(
        "publishedDate",
        rfq?.data?.published_date
          ? moment(rfq?.data?.published_date).format("MM/DD/YYYY")
          : null,
      );

      setValue("vehicleId", rfq?.data?.ContractType?.id);
      setApiVendor(rfq?.data);
      setValue("Valid_For", rfq?.data?.valid_for ? rfq?.data?.valid_for : "");
      // setValue("custom_fields", rfq?.data?.custom_fields || []);
      const transformedCustomFields = (rfq?.data?.custom_fields || []).map(
        (field) => {
          if (field.type === "date" && field.value) {
            return {
              ...field,
              value: moment(field.value).format("MM/DD/YYYY"),
            };
          }
          return field;
        },
      );
      setValue("custom_fields", transformedCustomFields);
      setValue(
        "estimateddelivery",
        rfq?.data?.estimated_delivery ? rfq?.data?.estimated_delivery : "",
      );
      setValue(
        "payment_terms",
        rfq?.data?.payment_term ? rfq?.data?.payment_term : "",
      );

      if (
        rfq?.data?.shipping_method === "N/A" ||
        rfq?.data?.shipping_method === null ||
        rfq?.data?.shipping_method === ""
      ) {
        setValue("shipping_method", "");
      } else {
        setValue("shipping_method", rfq?.data?.shipping_method);
      }

      setValue(
        "shipping_method_detail",
        rfq?.data?.shipping_method_detail
          ? rfq?.data?.shipping_method_detail
          : "",
      );

      setValue(
        "payment_term_detail",
        rfq?.data?.payment_term_detail ? rfq?.data?.payment_term_detail : "",
      );

      setValue(
        "shipping_terms",
        rfq?.data?.shipping_term ? rfq?.data?.shipping_term : "",
      );

      setValue(
        "contractOfficerName",
        rfq?.data?.rfqKo?.name ? rfq?.data?.rfqKo?.name : "",
      );
      setValue(
        "contractOfficerEmail",
        rfq?.data?.rfqKo?.email ? rfq?.data?.rfqKo?.email : "",
      );
      setValue(
        "contractOfficerPhone",
        rfq?.data?.rfqKo?.phone ? rfq?.data?.rfqKo?.phone : "",
      );
      setValue(
        "contractOfficerAddress",
        rfq?.data?.rfqKo?.address ? rfq?.data?.rfqKo?.address : "",
      );

      setValue(
        "shippingCustomerName",
        rfq?.data?.rfqShipping?.name ? rfq?.data?.rfqShipping?.name : "",
      );

      setValue(
        "shippingCustomerEmail",
        rfq?.data?.rfqShipping?.email ? rfq?.data?.rfqShipping?.email : "",
      );
      setValue(
        "shippingCustomerPhone",
        rfq?.data?.rfqShipping?.phone ? rfq?.data?.rfqShipping?.phone : "",
      );
      setValue(
        "shippingCustomerAddress",
        rfq?.data?.rfqShipping?.address ? rfq?.data?.rfqShipping?.address : "",
      );

      setValue(
        "BillingCustomerName",
        rfq?.data?.rfqBilling?.name ? rfq?.data?.rfqBilling?.name : "",
      );
      setValue(
        "BillingCustomerEmail",
        rfq?.data?.rfqBilling?.email ? rfq?.data?.rfqBilling?.email : "",
      );
      setValue(
        "BillingCustomerPhone",
        rfq?.data?.rfqBilling?.phone ? rfq?.data?.rfqBilling?.phone : "",
      );
      setValue(
        "BillingCustomerAddress",
        rfq?.data?.rfqBilling?.address ? rfq?.data?.rfqBilling?.address : "",
      );

      setValue(
        "sales_lead_email",
        rfq?.data?.sales_lead_email ? rfq?.data?.sales_lead_email : "",
      );
      setValue(
        "sales_lead_name",
        rfq?.data?.sales_lead_name ? rfq?.data?.sales_lead_name : "",
      );

      setValue(
        "sales_lead_name",
        rfq?.data?.sales_lead_name ? rfq?.data?.sales_lead_name : "",
      );
      setValue(
        "sales_lead_username",
        rfq?.data?.sales_lead_username ? rfq?.data?.sales_lead_username : "",
      );

      setValue(
        "sales_lead_phone",
        rfq?.data?.sales_lead_phone ? rfq?.data?.sales_lead_phone : "",
      );
      setValue(
        "sameShipNameasKO",
        rfq?.data?.is_shipping_same_ko ? rfq?.data?.is_shipping_same_ko : "",
      );

      setValue(
        "initial_consolidation",
        rfq?.data?.initial_consolidation === 1 ? true : false,
      );
      setValue(
        "sameBillNameasKO",
        rfq?.data?.is_billing_same_ko ? rfq?.data?.is_billing_same_ko : "",
      );
      // card  //
      const initialOriginalVendors = {};
      rfq?.data?.RfqProducts.forEach((product, index) => {
        setValue(`cards[${index}].skuDescription`, product?.description);
        setValue(
          `cards[${index}].purchase_description`,
          product?.purchase_description,
        );
        setValue(
          `cards[${index}].clin`,
          product?.clin_id ? product?.clin_id : null,
        );
        setValue(
          `cards[${index}].vendorPartner`,
          product?.display_name, // using display_name instead of Vendor?.display_name object
        );
        setValue(`cards[${index}].skuIdUnique`, product?.sku_id);
        setValue(`cards[${index}].skuId`, product?.sku_display_name);
        setValue(`cards[${index}].rowId`, product?.raw_sku_id);
        setValue(
          `cards[${index}].productName`,
          product?.name ?? product?.Product?.name,
        );
        setValue(
          `cards[${index}].cost`,
          trimTrailingZeros(product?.aspetto_price),
        );
        setValue(
          `cards[${index}].margin`,
          trimTrailingZeros(product?.margin_percent),
        );
        setValue(`cards[${index}].qty`, trimTrailingZeros(product?.quantity));
        setValue(`cards[${index}].um`, product?.unit_of_measure);
        setValue(`cards[${index}].customerCost`, product?.customer_price);
        setValue(`cards[${index}].totalSkuCost`, product?.total_price);
        initialOriginalVendors[index] = product?.Product?.Vendor?.display_name;
      });
      setValue("originalVendors", initialOriginalVendors);

      const parsedCosts = rfq?.data?.other_cost_json
        ? JSON.parse(rfq.data.other_cost_json)
        : [];
      parsedCosts.forEach((cost, index) => {
        setValue(`otherCost[${index}].Name`, cost?.Name);
        setValue(`otherCost[${index}].Amount`, cost?.Amount);
      });
      setValue("tax", rfq?.data?.tax);
      setValue("shippingCost", rfq?.data?.shipping_cost);
      setValue("totalCostAfterMargin", rfq?.data?.total_cost_after_margin);
      setValue("totalCostBeforeMargin", rfq?.data?.total_cost_before_margin);
    }
  };

  const { rfq_id } = useParams();

  const schema = yup.object().shape({
    // step 1
    notes: yup.array().of(
      yup.object().shape({
        section: yup.string().required("Section is required"),
        notesdata: yup.array().of(
          yup.object().shape({
            note: yup.string().required("Note cannot be blank"),
          }),
        ),
      }),
    ),

    custom_fields: yup.array().of(
      yup.object().shape({
        field_name: yup.string().required("Field name is required"),
        value: yup.string().optional(""),
      }),
    ),

    // notes: yup.array().of(
    //   yup.object().shape({
    //     section: yup.string().required("Section is required"),
    //     notesdata: yup
    //       .array()
    //       .of(
    //         yup.object().shape({
    //           note: yup.string().required("Note cannot be blank"),
    //         })
    //       )
    //       .test(
    //         "notesdata-not-empty-if-section",
    //         "Notes cannot be empty if section is selected",
    //         function (value) {
    //           const { section } = this.parent;
    //           // If section exists and is non-empty, make sure notesdata has items
    //           if (section && Array.isArray(value)) {
    //             return value.length > 0;
    //           }
    //           return true; // No section? skip
    //         }
    //       ),
    //   })
    // ),

    // NEW CHANGES
    // opportunityName: yup.string().required("Opportunity Name is required"),
    opportunityName: yup.string().optional(),
    rfqId: yup
      .string()
      // .min(1, "Opportunity ID required.")
      .matches(
        /^[a-zA-Z0-9/ .\-–—]+$/,
        "Opportunity Id can contain only letters, numbers, spaces, /, -, – , — and dots",
      )
      .required("Opportunity ID required."),
    contractVehicle: yup
      .number()
      .transform((value) => (value === "" ? null : value))
      .typeError("required.")
      .required("required.")
      .test("is-valid-number", "not nagetive.", (value) => {
        return value === null || (!isNaN(value) && value !== -1);
      }),
    // ordertype: yup.string().required("Order Type is required"),
    // order_Payment_Type: yup.string().required("Order Payment Type is required"),

    publishedDate: yup.date().required("Published Date is required"),
    // dueDate: yup.date().required("Due Date is required"),
    organization_name: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable()
      .min(2, "Must be at least 2 character")
      .max(100, "Must be at most 100 characters"),

    Opportunity_Description: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable()
      .min(5, "Must be at least 5 characters")
      .max(500, "Must be at most 500 characters"),
    Valid_For: yup.string().nullable(),

    //  step 2
    estimateddelivery: yup.string().optional(),
    payment_terms: yup.string().optional(),
    shipping_method: yup.string().optional(),
    shipping_method_detail: yup.string().optional(),
    payment_term_detail: yup.string().nullable(),
    // shipping_method_detail: yup.string().optional(),
    contractOfficerName: yup.string().nullable(),
    contractOfficerEmail: yup
      .string()
      .nullable()
      .email("Email must be a valid email address"),
    // contractOfficerPhone: yup
    //   .string()
    //   .transform((value) => (value === "" ? null : value))
    //   .nullable()
    //   .min(10, "Phone number must be at least 10 digits")
    //   .optional(),
    contractOfficerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    // .test("valid-phone", "Invalid phone number", (value) => {
    //   if (!value) {
    //     return true;
    //   }
    //   if (typeof value === "string" && value.trim() !== "") {
    //     return isValidPhoneNumber(value);
    //   }
    //   return false;
    // })
    // .optional(),
    contractOfficerAddress: yup.string().nullable(),
    shippingCustomerName: yup.string().nullable(),
    shippingCustomerEmail: yup
      .string()
      .nullable()
      .email("Email must be a valid email address"),
    shippingCustomerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    // .test("valid-phone", "Invalid phone number", (value) => {
    //   if (!value) {
    //     return true;
    //   }
    //   if (typeof value === "string" && value.trim() !== "") {
    //     return isValidPhoneNumber(value);
    //   }
    //   return false;
    // })
    // .optional(),
    shippingCustomerAddress: yup.string().nullable(),
    BillingCustomerName: yup.string().nullable(),
    BillingCustomerEmail: yup
      .string()
      .nullable()
      .email("Email must be a valid email address"),
    BillingCustomerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    // .test("valid-phone", "Invalid phone number", (value) => {
    //   if (!value) {
    //     return true;
    //   }
    //   if (typeof value === "string" && value.trim() !== "") {
    //     return isValidPhoneNumber(value);
    //   }
    //   return false;
    // })
    // .optional(),
    // BillingCustomerPhone: yup
    //   .string()
    //   .transform((value) => (value === "" ? null : value))
    //   .nullable()
    //   .min(10, "Phone number must be at least 10 digits")
    //   .optional(),
    BillingCustomerAddress: yup.string().nullable(),

    // sales lead
    // sales_lead_username: yup.string().required("Sales Lead Username is required")

    sales_lead_name: yup.string().required("Sales Lead Name is required"),
    sales_lead_email: yup
      .string()
      .email("Email must be a valid email address")
      .required("Sales Lead Email is required"),
    sales_lead_phone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .min(10, "Phone number must be at least 10 digits")
      .required("Sales Lead Phone is required"),
    notification_emails: yup.array().of(yup.string().email("Invalid email")),
    rfqwon_notification_emails: yup
      .array()
      .of(yup.string().email("Invalid email")),

    orderpending_notification_emails: yup
      .array()
      .of(yup.string().email("Invalid email")),

    orderprogress_notification_emails: yup
      .array()
      .of(yup.string().email("Invalid email")),

    // sales_lead_name: yup.string().required("Sales Lead Name is required"),

    // Notes: yup.array().of(
    //   yup.object().shape({
    //     description: yup
    //       .string()
    //       .transform((value) => (value === "" ? null : value))
    //       .nullable()
    //       .min(10, "Description must be at least 10 characters")
    //       .max(200, "Description must be at most 200 characters")
    //       .optional(),
    //   })
    // ),

    otherCost: yup.array().of(
      yup.object({
        Name: yup.string().required(),
        Amount: yup
          .number()
          .transform((value) => (value === "" ? null : value))
          .typeError("Must be a number.")
          .required("required.")
          .test("is-valid-number", "not nagetive.", (value) => {
            return value === null || (!isNaN(value) && value !== -1);
          })
          .min(0, "at least 0."),
      }),
    ),

    cards: yup.array().of(
      yup.object({
        vendorPartner: yup.string().nullable().optional(),
        productName: yup.string().nullable().optional(),
        clin: yup.string().nullable().optional(),
        skuId: yup
          .string()
          .nullable()
          .transform((v) => (v === "" ? null : v))
          .min(1, "required."),

        skuDescription: yup
          .string()
          .nullable()
          .transform((v) => (v === "" ? null : v))
          .optional(),

        cost: yup
          .number()
          .nullable()
          .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? null : value,
          )
          .typeError("Must be a number.")
          .test("is-valid-number", "not negative.", (v) => {
            return v === null || (!isNaN(v) && v >= 0);
          }),

        qty: yup
          .number()
          .nullable()
          .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? null : value,
          )
          .typeError("Must be a number.")
          .test("is-valid-number", "not negative.", (v) => {
            return v === null || (!isNaN(v) && v >= 0);
          }),

        margin: yup
          .number()
          .nullable()
          .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? null : value,
          )
          .typeError("Must be a number.")
          .test("is-valid-number", "not negative.", (v) => {
            return v === null || (!isNaN(v) && v >= 0);
          }),

        customerCost: yup
          .number()
          .nullable()
          .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? null : value,
          )
          .typeError("Must be a number.")
          .test("is-valid-number", "not negative.", (v) => {
            return v === null || (!isNaN(v) && v >= 0);
          }),

        um: yup.string().nullable().optional(),
      }),
    ),

    // cards: yup.array().of(
    //   yup.object({
    //     vendorPartner: yup.string().nullable(),
    //     skuId: yup.string().min(1, "required.").nullable(),
    //     skuDescription: yup.string().optional(),
    //     // .required("Description is required.")
    //     // .min(5, "Description must be at least 5 characters."),
    //     // .max(100, "Description must be at most 100 characters."),
    //     cost: yup
    //       .number()
    //       .transform((value) => (value === "" ? null : value))
    //       .typeError("Must be a number.")
    //       .required("required.")
    //       .test("is-valid-number", "not nagetive.", (value) => {
    //         return value === null || (!isNaN(value) && value !== -1);
    //       })
    //       .min(1, "at least 1."),
    //     qty: yup
    //       .number()
    //       .transform((value) => (value === "" ? null : value))
    //       .typeError("Must be a number.")
    //       .required("required.")
    //       .test("is-valid-number", "not nagetive.", (value) => {
    //         return value === null || (!isNaN(value) && value !== -1);
    //       })
    //       .min(1, "at least 1."),
    //     margin: yup
    //       .number()
    //       .transform((value) => (value === "" ? null : value))
    //       .typeError("Must be a number.")
    //       // .required("required.")
    //       .test("is-valid-number", "not nagetive.", (value) => {
    //         return value === null || (!isNaN(value) && value !== -1);
    //       })
    //       .min(0, "Minimum 0%."),
    //     customerCost: yup
    //       .number()
    //       .transform((value) => (value === "" ? null : value))
    //       .typeError("Must be a number.")
    //       .required("required.")
    //       .test("is-valid-number", "not nagetive.", (value) => {
    //         return value === null || (!isNaN(value) && value !== -1);
    //       }),
    //     um: yup.string().nullable(),
    //   })
    // ),
  });

  useIdleLogout();

  const onCopyRfqSuccess = (res) => {
    selectedCopy.forEach((field) => {
      switch (field) {
        case "Opportunity Type":
          setValue(
            "opportunityType",
            res?.data?.opportunity_type ? res?.data?.opportunity_type : "",
          );
          break;

        case "Contract Vehicle":
          setValue(
            "contractVehicle",
            res?.data?.contract_type_id ? res?.data?.contract_type_id : null,
          );

          break;
        case "Organization Name":
          setValue(
            "organization_name",
            res?.data?.organization_name ? res?.data?.organization_name : "",
          );
          break;
        case "Order Description":
          setValue("Opportunity_Description", res?.data?.brief);
          break;

        case "Date Created":
          setValue(
            "publishedDate",
            res?.data?.published_date
              ? moment(res?.data?.published_date).format("MM/DD/YYYY")
              : null,
          );
          break;
        case "Valid For":
          setValue(
            "Valid_For",
            res?.data?.valid_for ? res?.data?.valid_for : "",
          );
          break;

        case "Contracting Name":
          setValue(
            "contractOfficerName",
            res?.data?.rfqKo?.name ? res?.data?.rfqKo?.name : "",
          );
          break;
        case "Contracting Email":
          setValue(
            "contractOfficerEmail",
            res?.data?.rfqKo?.email ? res?.data?.rfqKo?.email : "",
          );
        case "Contracting Phone":
          setValue(
            "contractOfficerPhone",
            res?.data?.rfqKo?.phone ? res?.data?.rfqKo?.phone : "",
          );
          break;
        case "Contracting Address":
          setValue(
            "contractOfficerAddress",
            res?.data?.rfqKo?.address ? res?.data?.rfqKo?.address : "",
          );
          break;
        case "Shipping Name":
          setValue(
            "shippingCustomerName",
            res?.data?.rfqShipping?.name ? res?.data?.rfqShipping?.name : "",
          );
          break;
        case "Shipping Phone":
          setValue(
            "shippingCustomerPhone",
            res?.data?.rfqShipping?.phone ? res?.data?.rfqShipping?.phone : "",
          );
          break;
        case "Shipping Email":
          setValue(
            "shippingCustomerEmail",
            res?.data?.rfqShipping?.email ? res?.data?.rfqShipping?.email : "",
          );
          break;
        case "Shipping Address":
          setValue(
            "shippingCustomerAddress",
            res?.data?.rfqShipping?.address
              ? res?.data?.rfqShipping?.address
              : "",
          );
          break;

        case "Billing Name":
          setValue(
            "BillingCustomerName",
            res?.data?.rfqBilling?.name ? res?.data?.rfqBilling?.name : "",
          );
          break;
        case "Billing Email":
          setValue(
            "BillingCustomerEmail",
            res?.data?.rfqBilling?.email ? res?.data?.rfqBilling?.email : "",
          );
          break;
        case "Billing Phone":
          setValue(
            "BillingCustomerPhone",
            res?.data?.rfqBilling?.phone ? res?.data?.rfqBilling?.phone : "",
          );
          break;
        case "Billing Address":
          setValue(
            "BillingCustomerAddress",
            res?.data?.rfqBilling?.address
              ? res?.data?.rfqBilling?.address
              : "",
          );
          break;

        case "Shipping Method":
          setValue(
            "shipping_method",
            res?.data?.shipping_method ? res?.data?.shipping_method : "",
          );
          break;
        case "Shipping Terms":
          setValue(
            "shipping_terms",
            res?.data?.shipping_terms ? res?.data?.shipping_terms : "",
          );
          break;
        case "Payment Terms":
          setValue(
            "payment_terms",
            res?.data?.payment_term ? res?.data?.payment_term : "",
          );
          break;
        case "Estimated Delivery":
          setValue(
            "estimateddelivery",
            res?.data?.estimated_delivery
              ? res?.data?.estimated_delivery
              : null,
          );
          break;
        case "Shipping Cost($)":
          setValue(
            "shippingCost",
            res?.data?.shipping_cost ? res?.data?.shipping_cost : null,
          );
          break;
        case "Tax($)":
          setValue("tax", res?.data?.tax);
          break;
        case "Other Cost":
          const parsedCosts = res?.data?.other_cost_json
            ? JSON.parse(res.data.other_cost_json)
            : [];
          parsedCosts.forEach((cost, index) => {
            setValue(`otherCost[${index}].Name`, cost?.Name);
            setValue(`otherCost[${index}].Amount`, cost?.Amount);
          });
          break;
        case "Total Cost Before Margin($)":
          setValue(
            "totalCostBeforeMargin",
            res?.data?.total_cost_before_margin,
          );
          break;
        case "Total Cost After Margin($)":
          setValue("totalCostAfterMargin", res?.data?.total_cost_after_margin);
          break;
        case "Total Cost After Margin($)":
          setValue("totalCostAfterMargin", res?.data?.total_cost_after_margin);
          break;
        case "Product":
          res?.data?.RfqProducts.forEach((product, index) => {
            setValue(`cards[${index}].skuDescription`, product?.description);
            setValue(
              `cards[${index}].purchase_description`,
              product?.purchase_description,
            );
            setValue(
              `cards[${index}].vendorPartner`,
              product?.Vendor?.display_name,
            );
            setValue(`cards[${index}].productName`, product?.name);
            setValue(`cards[${index}].skuIdUnique`, product?.sku_id);
            setValue(`cards[${index}].skuId`, product?.sku_display_name);
            setValue(
              `cards[${index}].cost`,
              trimTrailingZeros(product?.aspetto_price),
            );
            setValue(`cards[${index}].rowId`, product?.raw_sku_id);
            setValue(
              `cards[${index}].margin`,
              trimTrailingZeros(product?.margin_percent),
            );
            setValue(`cards[${index}].qty`, trimTrailingZeros(product?.quantity));
            setValue(`cards[${index}].um`, product?.unit_of_measure);
            setValue(`cards[${index}].customerCost`, product?.customer_price);
            setValue(`cards[${index}].totalSkuCost`, product?.total_price);
          });
          break;
        default:
          break;
      }
    });
  };

  const transformData = (resData) => {
    return {
      notes: resData.map((section) => ({
        section: section.name,
        custom_id: section.custom_id,
        notesdata: section.notes.map((noteItem) => ({
          note: noteItem.note,
          user: noteItem.User.username,
          updateAt: noteItem.updated_at,
          custom_id: noteItem.custom_id || undefined,
        })),
      })),
    };
  };

  const onSingleNotesSuccess = (res) => {
    if (res?.data) {
      const transformedData = transformData(res.data);
      setValue("notes", transformedData.notes);
    }
  };

  const onSingleRfqSuccess = (res) => {
    if (res?.data) {
      setValue(
        "opportunityName",
        rfq?.data?.opportunity_name ? rfq?.data?.opportunity_name : "",
      );
      // setValue("custom_fields", rfq?.data?.custom_fields || []);
      const transformedCustomFields = (rfq?.data?.custom_fields || []).map(
        (field) => {
          if (field.type === "date" && field.value) {
            return {
              ...field,
              value: moment(field.value).format("MM/DD/YYYY"),
            };
          }
          return field;
        },
      );
      setValue("custom_fields", transformedCustomFields);
      setValue("rfqId", rfq?.data?.rfq_id ? rfq?.data?.rfq_id : null);
      setValue(
        "contractVehicle",
        rfq?.data?.contract_type_id ? rfq?.data?.contract_type_id : null,
      );
      setValue(
        "organization_name",
        rfq?.data?.organization_name ? rfq?.data?.organization_name : "",
      );
      setValue("Opportunity_Description", rfq?.data?.brief);
      setValue(
        "publishedDate",
        rfq?.data?.published_date
          ? moment(rfq?.data?.published_date).format("MM/DD/YYYY")
          : null,
      );
      setValue("vehicleId", res?.data?.ContractType?.id);
      setValue(
        "contractVehicletype",
        res?.data?.ContractType?.contract_vehicle_type
          ? res?.data?.ContractType?.contract_vehicle_type
          : null,
      );
      setValue("order_Payment_Type", rfq?.data?.order_payment_type);
      setValue("ordertype", rfq?.data?.order_type ?? "DS");
      setApiVendor(rfq?.data);

      setisOrderMade(rfq?.isOrder);

      setValue("vehicleId", rfq?.data?.ContractType?.id);

      setValue("Valid_For", rfq?.data?.valid_for ? rfq?.data?.valid_for : "");
      setValue(
        "estimateddelivery",
        rfq?.data?.estimated_delivery ? rfq?.data?.estimated_delivery : "",
      );
      setValue(
        "payment_terms",
        rfq?.data?.payment_term ? rfq?.data?.payment_term : "",
      );
      setValue(
        "shipping_method",
        rfq?.data?.shipping_method ? rfq?.data?.shipping_method : "",
      );
      setValue(
        "shipping_method_detail",
        rfq?.data?.shipping_method_detail
          ? rfq?.data?.shipping_method_detail
          : "",
      );
      const emailsString = res?.data?.team_emails;
      const emailsArray = emailsString ? emailsString.split(",") : [];
      setValue("notification_emails", emailsArray);

      const rfqwonEmailsString = rfq?.data?.rfq_won_notification_emails;
      const rfqwonEmailsArray = rfqwonEmailsString
        ? rfqwonEmailsString.split(",")
        : [];
      setValue("rfqwon_notification_emails", rfqwonEmailsArray);

      const orderpendingEmailsString =
        rfq?.data?.order_pending_notification_emails;
      const orderpendingEmailsArray = orderpendingEmailsString
        ? orderpendingEmailsString.split(",")
        : [];
      setValue("orderpending_notification_emails", orderpendingEmailsArray);

      const orderprogressEmailsString =
        rfq?.data?.order_progress_notification_emails;
      const orderprogressEmailsArray = orderprogressEmailsString
        ? orderprogressEmailsString.split(",")
        : [];
      setValue("orderprogress_notification_emails", orderprogressEmailsArray);

      setValue("notifyEmails", rfq?.data?.notify_emails === 1 ? "1" : "0");
      setValue(
        "notifyEmailsVendor",
        rfq?.data?.notify_emails_vendor === 1 ? "1" : "0",
      );
      setValue(
        "payment_term_detail",
        rfq?.data?.payment_term_detail ? rfq?.data?.payment_term_detail : "",
      );
      setValue(
        "shipping_terms",
        rfq?.data?.shipping_term ? rfq?.data?.shipping_term : "",
      );
      setValue(
        "contractOfficerName",
        rfq?.data?.rfqKo?.name ? rfq?.data?.rfqKo?.name : "",
      );
      setValue(
        "contractOfficerEmail",
        rfq?.data?.rfqKo?.email ? rfq?.data?.rfqKo?.email : "",
      );
      setValue(
        "contractOfficerPhone",
        rfq?.data?.rfqKo?.phone ? rfq?.data?.rfqKo?.phone : "",
      );
      setValue(
        "contractOfficerAddress",
        rfq?.data?.rfqKo?.address ? rfq?.data?.rfqKo?.address : "",
      );
      setValue(
        "shippingCustomerName",
        rfq?.data?.rfqShipping?.name ? rfq?.data?.rfqShipping?.name : "",
      );
      setValue(
        "shippingCustomerEmail",
        rfq?.data?.rfqShipping?.email ? rfq?.data?.rfqShipping?.email : "",
      );
      setValue(
        "shippingCustomerPhone",
        rfq?.data?.rfqShipping?.phone ? rfq?.data?.rfqShipping?.phone : "",
      );
      setValue(
        "shippingCustomerAddress",
        rfq?.data?.rfqShipping?.address ? rfq?.data?.rfqShipping?.address : "",
      );
      setValue(
        "BillingCustomerName",
        rfq?.data?.rfqBilling?.name ? rfq?.data?.rfqBilling?.name : "",
      );
      setValue(
        "BillingCustomerEmail",
        rfq?.data?.rfqBilling?.email ? rfq?.data?.rfqBilling?.email : "",
      );
      setValue(
        "BillingCustomerPhone",
        rfq?.data?.rfqBilling?.phone ? rfq?.data?.rfqBilling?.phone : "",
      );
      setValue(
        "BillingCustomerAddress",
        rfq?.data?.rfqBilling?.address ? rfq?.data?.rfqBilling?.address : "",
      );
      setRfqStatus(res?.data?.status);
      setInitialVal(0);
    }
  };

  const { data: rfq, postData: fetchSingleRfq } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_RFQ,
  );
  const { data: notesData, postData: fetchNotes } = usePostRequest(
    API_ENDPOINTS.GET_NOTES,
  );

  const steps = [
    "General",
    "Billing & Shipping",
    "Products",
    "Attachments",
    "Notes",
    "Communication",
  ];

  const [currentStep, setCurrentStep] = useState(1);

  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      shippingCostEnabled: true,
      taxEnabled: true,
      tax: parseFloat("0.00"),
      shippingCost: parseFloat("0.00"),
      originalVendors: {},
      // sales_lead_email: ,
      // sales_lead_name : ,
      // sales_lead_phone: ,
    },
  });

  const {
    handleSubmit,
    setError,
    reset,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = methods;

  console.log("errors =>", errors);

  const onError = (error) => {
    if (error?.errors) {
      const updatedErrors = {};
      Object.keys(error.errors).forEach((field) => {
        if (error.errors[field]?.message) {
          updatedErrors[field] = {
            message: error.errors[field]?.message,
          };
        }
      });

      setServerErr((prevState) => ({
        ...prevState,
        ...updatedErrors,
      }));
      setShow(true);
    }
    toast.error(`${error?.message}${error?.error ? ` (${error.error})` : ""}`);
  };

  const { isLoading: createLoading, postData: createRFQ } = usePostRequest(
    API_ENDPOINTS.CREATE_RFQ,
  );

  const { isLoading: notesLoading, postData: createNotes } = usePostRequest(
    API_ENDPOINTS.CREATE_NOTES,
  );

  const { isLoading: UpdateLoading, postData: updateRFQ } = usePostRequest(
    API_ENDPOINTS.UPDATE_RFQ,
  );

  const { isLoading, postData: uploadImage } = usePostRequest(
    API_ENDPOINTS.UPLOAD_RFQ_IMG,
  );

  const formatPhone = (phone) => {
    if (!phone) return null;

    // Check if phone starts with '+'
    const startsWithPlus = phone.startsWith("+");

    // Remove all non-digit characters
    const cleaned = phone.replace(/\D/g, "");

    // Add '+' back if it was there
    return startsWithPlus ? `+${cleaned}` : cleaned ? cleaned : null;
  };

  const onSubmit = (data, overrides = {}) => {
    const custom_fieldsTransformed = data?.custom_fields?.map((fields) => {
      if (fields?.type === "date") {
        return {
          type: fields?.type,
          value: moment(fields?.value).format("YYYY-MM-DD"),
          field_name: fields?.field_name,
        };
      } else if (fields?.type === "dropdown") {
        return {
          type: fields?.type,
          field_name: fields?.field_name,
          value: fields?.value || "",
          options: Array.isArray(fields?.options) ? fields.options : [], // preserve the options array
        };
      } else {
        return {
          type: fields?.type,
          value: fields?.value,
          field_name: fields?.field_name,
        };
      }
    });
    const transformedProducts = data?.cards?.map((product) => {
      return {
        vendor_name: product?.vendorPartner,
        sku_id: product?.skuIdUnique ? product?.skuIdUnique : product?.skuId, // sku_display_name will go if there is no sku_id present (case if user enteres manual values)
        sku_display_name: product?.skuId,
        clin_id: product?.clin ? product?.clin : null,
        name: product?.productName ? product?.productName : null,
        description: product?.skuDescription ? product?.skuDescription : null,
        raw_sku_id: product?.rowId,
        purchase_description: product?.purchase_description
          ? product?.purchase_description
          : null,
        quantity: product?.qty ? product?.qty : 0,
        aspetto_price: product?.cost ? Number(product?.cost) : 0,
        customer_price: product?.customerCost
          ? Number(product?.customerCost)
          : Number(0),
        margin_percent: product?.margin ? Number(product?.margin) : 0,
        total_price: product?.totalSkuCost ? Number(product?.totalSkuCost) : 0,
        um: product?.um,
      };
    });

    const payload = {
      attachment_id: formId,
      opportunity_type: data?.opportunityType ? data?.opportunityType : null,
      opportunity_name: data?.opportunityName ? data?.opportunityName : null,
      initial_consolidation: Number(data?.initial_consolidation),
      rfq_id: data?.rfqId || rfq_id,
      contract_type_id: Number(data?.contractVehicle),
      published_date: moment(data?.publishedDate).format("YYYY-MM-DD"),
      order_type: data?.ordertype ? data?.ordertype : null,
      order_payment_type: data?.order_Payment_Type
        ? data?.order_Payment_Type
        : null,
      // due_date: moment(data?.dueDate).format("YYYY-MM-DD"),
      // sales_lead_username: data?.sales_lead_username
      //   ? data?.sales_lead_username
      //   : null,
      sales_lead_name: data?.sales_lead_name ? data?.sales_lead_name : null,
      sales_lead_email: data?.sales_lead_email ? data?.sales_lead_email : null,
      sales_lead_phone: data?.sales_lead_phone ? data?.sales_lead_phone : null,
      team_emails: data?.notification_emails?.length
        ? data.notification_emails.join(",")
        : null,
      rfq_won_notification_emails: data?.rfqwon_notification_emails?.length
        ? data.rfqwon_notification_emails.join(",")
        : null,
      order_pending_notification_emails: data?.orderpending_notification_emails
        ?.length
        ? data.orderpending_notification_emails.join(",")
        : null,
      order_progress_notification_emails: data
        ?.orderprogress_notification_emails?.length
        ? data.orderprogress_notification_emails.join(",")
        : null,
      notify_emails: data?.notifyEmails ? data?.notifyEmails : 0,
      notify_emails_vendor: data?.notifyEmailsVendor
        ? data?.notifyEmailsVendor
        : 0,
      sales_lead_username: data?.sales_lead_username
        ? data?.sales_lead_username
        : null,
      organization_name: data?.organization_name
        ? data?.organization_name
        : null,
      brief: data?.Opportunity_Description
        ? data?.Opportunity_Description
        : null,
      estimated_delivery: data?.estimateddelivery
        ? data?.estimateddelivery
        : null,
      payment_term: data?.payment_terms ? data?.payment_terms : null,
      payment_term_detail: data?.payment_term_detail
        ? data?.payment_term_detail
        : null,
      shipping_method: data?.shipping_method ? data?.shipping_method : null,
      shipping_method_detail: data?.shipping_method_detail
        ? data?.shipping_method_detail
        : null,
      shipping_term: data?.shipping_terms ? data?.shipping_terms : null,
      valid_for: data?.Valid_For ? data?.Valid_For : null,

      is_draft: data.isDraft ? data.isDraft : false,
      shipping_cost: data?.shippingCost ? Number(data?.shippingCost) : 0,
      tax: data?.tax,
      ko_detail: {
        name: data?.contractOfficerName ? data?.contractOfficerName : null,
        email: data?.contractOfficerEmail ? data?.contractOfficerEmail : null,
        // phone: data?.contractOfficerPhone ? data?.contractOfficerPhone : null,
        phone: formatPhone(data?.contractOfficerPhone),
        address: data?.contractOfficerAddress
          ? data?.contractOfficerAddress
          : null,
      },
      shipping_detail: {
        name: data?.shippingCustomerName ? data?.shippingCustomerName : null,
        email: data?.shippingCustomerEmail ? data?.shippingCustomerEmail : null,
        // phone: data?.shippingCustomerPhone ? data?.shippingCustomerPhone : null,
        phone: formatPhone(data?.shippingCustomerPhone),
        address: data?.shippingCustomerAddress
          ? data?.shippingCustomerAddress
          : null,
      },
      billing_detail: {
        name: data?.BillingCustomerName ? data?.BillingCustomerName : null,
        email: data?.BillingCustomerEmail ? data?.BillingCustomerEmail : null,
        // phone: data?.BillingCustomerPhone ? data?.BillingCustomerPhone : null,
        phone: formatPhone(data?.BillingCustomerPhone),
        address: data?.BillingCustomerAddress
          ? data?.BillingCustomerAddress
          : null,
      },
      status: overrides.force_status || rfqstatus || "PENDING",

      // status: rfqstatus ? rfqstatus : "DRAFT",
      custom_fields: custom_fieldsTransformed,

      // notes: data?.Notes,
      // files: [...data?.files],
      otherCost: data?.otherCost,
      products: [...transformedProducts],
      total_cost_before_margin: data?.totalCostBeforeMargin
        ? Number(data?.totalCostBeforeMargin)
        : null,
      total_cost_after_margin: data?.totalCostAfterMargin
        ? Number(data?.totalCostAfterMargin)
        : null,
    };

    const onSuccess = (res) => {
      posthog.capture("opportunity_created", {
        rfq_id: res?.rfq_id,
        contract_type: res?.contract_type,
        created_date: res?.created_date,
        status: res?.status,
        created_by: user?.email,
      });

      const notesPayload = {
        module_id: res?.rfq_id,
        module_type: "RFQ",
        notes: data.notes,
      };

      if (Array.isArray(notesPayload.notes) && notesPayload.notes.length > 0) {
        createNotes(notesPayload);
      }

      setIsModalOpen({
        show: true,
        title: `Opportunity Created Successfully in ${res?.status}!`,
        message: `Created by ${user?.first_name} ${
          user?.last_name
        }. Opportunity ID is 
                <strong style="color: orange;">${
                  res.rfq_id
                }</strong>. This opportunity is for ${
                  res?.contract_type
                }. Created on ${moment(res?.created_date).format("MM/DD/YYYY")}.`,
        btntext: "Return Home",
        newbtn: "Create New Opportunity",
      });
      reset();
    };

    const onSuccessUpdate = (res) => {
      posthog.capture("opportunity_updated", {
        rfq_id: res?.rfq_id,
        contract_type: res?.contract_type,
        updated_by: user?.email,
      });

      // const notesPayload = {
      //   module_id: res?.rfq_id,
      //   module_type: "RFQ",
      //   notes: data.notes,
      // };

      // if (Array.isArray(notesPayload.notes) && notesPayload.notes.length > 0) {
      //   createNotes(notesPayload);
      // }

      setIsModalOpen({
        show: true,
        title: "Opportunity Updated Successfully!",
        message: `Updated by ${user?.username}. Opportunity ID is ${
          res.rfq_id
        }. This opportunity is for ${res?.contract_type}  Created on ${moment(
          res?.created_date,
        ).format("MM/DD/YYYY")}.`,
        btntext: "Return Home",
      });
      reset();
    };

    if (rfq && rfq_id) {
      updateRFQ(payload, onSuccessUpdate, onError);
    } else {
      createRFQ(payload, onSuccess, onError, API_ENDPOINTS.CREATE_RFQ);
    }
  };

  const refreshOrder = () => {
    fetchSingleRfq({ rfq_id, route_name: "edit" }, (res) => {
      setApiVendor(res.data);
    });
  };

  useEffect(() => {
    if (rfqCopy && !rfqDataFetchedcopy) {
      let rfq_id = rfqCopy;
      fetchSingleRfq({ rfq_id, route_name: "edit" }, onCopyRfqSuccess);
      setRfqDataFetchedcopy(true);
    }
    // else {
    //   setInitialVal(0);
    // }
  }, [rfqCopy, rfqDataFetchedcopy, fetchSingleRfq]);

  useEffect(() => {
    if (rfq_id && !rfqDataFetched) {
      fetchSingleRfq({ rfq_id, route_name: "edit", route_type: "rfq" }, onSingleRfqSuccess);
      setRfqDataFetched(true);
      setIsEditing(true);
    }
    //  else {
    //   setInitialVal(0);
    // }
  }, [rfq_id, rfqDataFetched, fetchSingleRfq]);

  useEffect(() => {
    if (rfq_id && !rfqDataFetched) {
      fetchNotes(
        {
          module_id: rfq_id,
          module_type: "RFQ",
        },
        onSingleNotesSuccess,
      );
    }
  }, [rfq_id, fetchNotes]);

  useEffect(() => {
    if (rfq && rfq_id) {
      if (rfq?.data?.attachment_id) {
        setFormId(rfq?.data?.attachment_id);
      }
      setValue(
        "opportunityType",
        rfq?.data?.opportunity_type ? rfq?.data?.opportunity_type : "",
      );
      setValue(
        "opportunityName",
        rfq?.data?.opportunity_name ? rfq?.data?.opportunity_name : "",
      );
      setValue("rfqId", rfq?.data?.rfq_id ? rfq?.data?.rfq_id : null);
      setValue(
        "contractVehicle",
        rfq?.data?.contract_type_id ? rfq?.data?.contract_type_id : null,
      );

      setisOrderMade(rfq?.isOrder);

      setValue(
        "organization_name",
        rfq?.data?.organization_name ? rfq?.data?.organization_name : "",
      );
      setValue("Opportunity_Description", rfq?.data?.brief);
      setValue("vehicleId", rfq?.data?.ContractType?.id);
      setValue(
        "contractVehicletype",
        rfq?.data?.ContractType?.contract_vehicle_type
          ? rfq?.data?.ContractType?.contract_vehicle_type
          : null,
      );
      setValue("order_Payment_Type", rfq?.data?.order_payment_type);
      setValue("ordertype", rfq?.data?.order_type ?? "DS");
      setValue(
        "publishedDate",
        rfq?.data?.published_date
          ? moment(rfq?.data?.published_date).format("MM/DD/YYYY")
          : null,
      );
      // setValue(
      //   "dueDate",
      //   rfq?.data?.due_date
      //     ? moment(rfq?.data?.due_date).format("MM/DD/YYYY")
      //     : ""
      // );
      setValue("vehicleId", rfq?.data?.ContractType?.id);
      setApiVendor(rfq?.data);
      setValue("Valid_For", rfq?.data?.valid_for ? rfq?.data?.valid_for : "");
      // setValue("custom_fields", rfq?.data?.custom_fields || []);
      const transformedCustomFields = (rfq?.data?.custom_fields || []).map(
        (field) => {
          if (field.type === "date" && field.value) {
            return {
              ...field,
              value: moment(field.value).format("MM/DD/YYYY"),
            };
          }
          return field;
        },
      );
      setValue("custom_fields", transformedCustomFields);
      setValue(
        "estimateddelivery",
        rfq?.data?.estimated_delivery ? rfq?.data?.estimated_delivery : "",
      );
      setValue(
        "payment_terms",
        rfq?.data?.payment_term ? rfq?.data?.payment_term : "",
      );

      if (
        rfq?.data?.shipping_method === "N/A" ||
        rfq?.data?.shipping_method === null ||
        rfq?.data?.shipping_method === ""
      ) {
        setValue("shipping_method", "");
      } else {
        setValue("shipping_method", rfq?.data?.shipping_method);
      }

      // setValue(
      //   "shipping_method",
      //   rfq?.data?.shipping_method ? rfq?.data?.shipping_method : ""
      // );

      setValue(
        "shipping_method_detail",
        rfq?.data?.shipping_method_detail
          ? rfq?.data?.shipping_method_detail
          : "",
      );

      setValue(
        "payment_term_detail",
        rfq?.data?.payment_term_detail ? rfq?.data?.payment_term_detail : "",
      );

      setValue(
        "shipping_terms",
        rfq?.data?.shipping_term ? rfq?.data?.shipping_term : "",
      );

      setValue(
        "contractOfficerName",
        rfq?.data?.rfqKo?.name ? rfq?.data?.rfqKo?.name : "",
      );
      setValue(
        "contractOfficerEmail",
        rfq?.data?.rfqKo?.email ? rfq?.data?.rfqKo?.email : "",
      );
      setValue(
        "contractOfficerPhone",
        rfq?.data?.rfqKo?.phone ? rfq?.data?.rfqKo?.phone : "",
      );
      setValue(
        "contractOfficerAddress",
        rfq?.data?.rfqKo?.address ? rfq?.data?.rfqKo?.address : "",
      );

      setValue(
        "shippingCustomerName",
        rfq?.data?.rfqShipping?.name ? rfq?.data?.rfqShipping?.name : "",
      );

      setValue(
        "shippingCustomerEmail",
        rfq?.data?.rfqShipping?.email ? rfq?.data?.rfqShipping?.email : "",
      );
      setValue(
        "shippingCustomerPhone",
        rfq?.data?.rfqShipping?.phone ? rfq?.data?.rfqShipping?.phone : "",
      );
      setValue(
        "shippingCustomerAddress",
        rfq?.data?.rfqShipping?.address ? rfq?.data?.rfqShipping?.address : "",
      );

      setValue(
        "BillingCustomerName",
        rfq?.data?.rfqBilling?.name ? rfq?.data?.rfqBilling?.name : "",
      );
      setValue(
        "BillingCustomerEmail",
        rfq?.data?.rfqBilling?.email ? rfq?.data?.rfqBilling?.email : "",
      );
      setValue(
        "BillingCustomerPhone",
        rfq?.data?.rfqBilling?.phone ? rfq?.data?.rfqBilling?.phone : "",
      );
      setValue(
        "BillingCustomerAddress",
        rfq?.data?.rfqBilling?.address ? rfq?.data?.rfqBilling?.address : "",
      );

      setValue(
        "sales_lead_email",
        rfq?.data?.sales_lead_email ? rfq?.data?.sales_lead_email : "",
      );
      setValue(
        "sales_lead_name",
        rfq?.data?.sales_lead_name ? rfq?.data?.sales_lead_name : "",
      );

      setValue(
        "sales_lead_name",
        rfq?.data?.sales_lead_name ? rfq?.data?.sales_lead_name : "",
      );
      setValue(
        "sales_lead_username",
        rfq?.data?.sales_lead_username ? rfq?.data?.sales_lead_username : "",
      );

      setValue(
        "sales_lead_phone",
        rfq?.data?.sales_lead_phone ? rfq?.data?.sales_lead_phone : "",
      );
      setValue(
        "sameShipNameasKO",
        rfq?.data?.is_shipping_same_ko ? rfq?.data?.is_shipping_same_ko : "",
      );

      setValue(
        "initial_consolidation",
        rfq?.data?.initial_consolidation === 1 ? true : false,
      );
      setValue(
        "sameBillNameasKO",
        rfq?.data?.is_billing_same_ko ? rfq?.data?.is_billing_same_ko : "",
      );
      // card  //
      const initialOriginalVendors = {};
      rfq?.data?.RfqProducts.forEach((product, index) => {
        setValue(`cards[${index}].skuDescription`, product?.description);
        setValue(
          `cards[${index}].purchase_description`,
          product?.purchase_description,
        );
        setValue(
          `cards[${index}].clin`,
          product?.clin_id ? product?.clin_id : null,
        );
        setValue(
          `cards[${index}].vendorPartner`,
          product?.display_name, // using display_name instead of Vendor?.display_name object
        );
        setValue(`cards[${index}].skuIdUnique`, product?.sku_id);
        setValue(`cards[${index}].skuId`, product?.sku_display_name);
        setValue(`cards[${index}].rowId`, product?.raw_sku_id);
        setValue(
          `cards[${index}].productName`,
          product?.name ?? product?.Product?.name,
        );
        setValue(
          `cards[${index}].cost`,
          trimTrailingZeros(product?.aspetto_price),
        );
        setValue(
          `cards[${index}].margin`,
          trimTrailingZeros(product?.margin_percent),
        );
        setValue(`cards[${index}].qty`, trimTrailingZeros(product?.quantity));
        setValue(`cards[${index}].um`, product?.unit_of_measure);
        setValue(`cards[${index}].customerCost`, product?.customer_price);
        setValue(`cards[${index}].totalSkuCost`, product?.total_price);
        initialOriginalVendors[index] = product?.Product?.Vendor?.display_name;
      });
      setValue("originalVendors", initialOriginalVendors);

      const parsedCosts = rfq?.data?.other_cost_json
        ? JSON.parse(rfq.data.other_cost_json)
        : [];
      parsedCosts.forEach((cost, index) => {
        setValue(`otherCost[${index}].Name`, cost?.Name);
        setValue(`otherCost[${index}].Amount`, cost?.Amount);
      });
      setValue("tax", rfq?.data?.tax);
      setValue("shippingCost", rfq?.data?.shipping_cost);
      setValue("totalCostAfterMargin", rfq?.data?.total_cost_after_margin);
      setValue("totalCostBeforeMargin", rfq?.data?.total_cost_before_margin);
      // setValue("status", rfq?.data?.status);
    }
  }, [rfq, setValue]);

  const handleStepChange = useCallback(
    (type) => {
      if (type === "next") {
        const currentData = methods.getValues();
        console.log(currentData);

        const fieldsToValidate = getFieldsForCurrentStep(currentStep);
        methods.trigger(fieldsToValidate).then((isValid) => {
          if (isValid) {
            if (currentStep <= steps.length - 1) {
              setCurrentStep((prev) => prev + 1);
            }
          } else {
            console.log("Errors:", methods.formState.errors);
          }
        });
      } else {
        if (currentStep > 1) {
          setCurrentStep((prev) => prev - 1);
        }
      }
    },
    [currentStep, methods],
  );

  // useEffect(() => {
  //   const handleKeyDown = (event) => {
  //     if (event.key === "ArrowRight") {
  //       handleStepChange("next");
  //     } else if (event.key === "ArrowLeft") {
  //       handleStepChange("prev");
  //     }
  //   };

  //   document.addEventListener("keydown", handleKeyDown);
  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, [handleStepChange]); // rebind listener when handleStepChange changes

  // if (rfq_id) {
  //   steps.push("Communication");
  // }

  useEffect(() => {
    if (user && !isEditing) {
      setValue("sales_lead_name", `${user.first_name} ${user.last_name}`);
      setValue("sales_lead_email", user.email);
      setValue("sales_lead_phone", user.phone);
      setValue("sales_lead_username", user.username);
    }
  }, [user]);

  const handleTabChange = (tabIndex) => {
    if (rfq_id) {
      const fieldsToValidate = getFieldsForCurrentStep(currentStep);
      methods.trigger(fieldsToValidate).then((isValid) => {
        if (isValid) {
          setCurrentStep(tabIndex);
        } else {
          console.log("Validation failed for step:", currentStep);
        }
      });
    }
  };

  useEffect(() => {
    if (!rfq_id) {
      // reset();
      reset({
        ...getValues(),
        sales_lead_name: `${user?.first_name} ${user?.last_name}`,
        sales_lead_email: user?.email,
        sales_lead_phone: user?.phone,
        sales_lead_username: user?.username,
      });
      setCurrentStep(1);
    } else {
    }
  }, [rfq_id, location.pathname]);

  const contractVehicle = watch("contractVehicle");

  const getFieldsForCurrentStep = (step, rfq_id) => {
    switch (step) {
      case 1:
        return [
          "opportunityName",
          "rfqId",
          "contractVehicle",
          "organization_name",
          "Opportunity_Description",
          "publishedDate",
          "custom_fields",
          // "dueDate",
        ];
      case 2:
        return [
          // "shipping_method",
          "shipping_method_detail",
          "payment_term_detail",
          "contractOfficerName",
          "contractOfficerEmail",
          "contractOfficerPhone",
          "contractOfficerAddress",

          "shippingCustomerName",
          "shippingCustomerEmail",
          "shippingCustomerPhone",
          "shippingCustomerAddress",

          "BillingCustomerName",
          "BillingCustomerEmail",
          "BillingCustomerPhone",
          "BillingCustomerAddress",
        ];
      case 3:
        return ["cards", "otherCost"];

      case 4:
        return [];
      case 5:
        return ["notes"];

      case 6:
        return [
          // "sales_lead_username",
          "sales_lead_phone",
          "sales_lead_email",
          "sales_lead_name",
        ];
      default:
        return [];
    }
  };

  useEffect(() => {
    const newFormId = generateUniqueId();
    setFormId(newFormId);
    reset();
  }, []);

  const ordertype = watch("ordertype");

  const orderTypeLabels = {
    DS: "Dropship",
    CRK: "Consolidate / Repack",
    M: "Manufacturing",
    KIT: "Kit",
    S: "Stock",
  };

  return (
    <>
      <SuccsessMsgModal
        show={isModalOpen.show}
        onHide={() =>
          setIsModalOpen(
            { ...isModalOpen, show: false },
            navigate("/list-opportunities"),
          )
        }
        title={isModalOpen.title}
        btntext={isModalOpen.btntext}
        message={isModalOpen.message}
        onSecondaryBtnClick={() => {
          setIsModalOpen({ ...isModalOpen, show: false });
          navigate("/create-rfq");
          setCurrentStep(1);
        }}
        newbtn={isModalOpen.newbtn}
      />
      <div className="page-header">
        <div className=" d-flex justify-content-between  align-items-center">
          <div>
            {/* <h2 className="page-title">
              {isEditing ? "Update Opportunity" : "Create Opportunity"}
            </h2> */}

            <h2 className="page-title">
              {isEditing ? (
                <>Update Opportunity</>
              ) : (
                <>
                  Create
                  <span style={{ color: "#f76707", margin: "0 4px" }}>
                    {orderTypeLabels[ordertype]}
                  </span>
                  Opportunity
                </>
              )}
            </h2>
          </div>

          {currentStep === 1 && contractVehicle === "9" && !isEditing && (
            <Button
              className="d-flex align-items-center gap-2 px-4 py-2"
              style={{
                backgroundColor: "#f76707",
                border: "none",
                borderRadius: "8px",
              }}
              onClick={() => setIsPDFOpen({ show: true })}
            >
              <IconCloudUpload size={20} /> <strong>Upload GSA PDF</strong>
            </Button>
          )}

          {/* <div>
            <Form.Group>
            COMMENTED THIS STATUS SELECT FOR NOW AS PER REQURIEMENT
              <Form.Label>Status</Form.Label>
              <InputGroup>
                <Form.Select
                  className={`Status_select`}
                  value={rfqstatus}
                  onChange={handleStatusChange}
                >
                  <option value="DRAFT">DRAFT</option>
                  <option value="PENDING">PENDING</option>
                  <option value="LOST">LOST</option>
                  <option value="WON">WON</option>
                  <option value="CANCELLED">CANCELLED</option>
                </Form.Select>
              </InputGroup>
            </Form.Group>
          </div> */}
        </div>
      </div>

      <Card>
        <Card.Body className="pt-3 pb-4 pt-md-5 pb-md-5">
          <Stepper
            steps={steps}
            currentStep={currentStep}
            onTabClick={rfq_id ? handleTabChange : undefined}
          />
          <FormProvider
            {...methods}
            className=""
            onSubmit={methods.handleSubmit(onSubmit)}
          >
            <Form autoComplete="off" onSubmit={methods.handleSubmit(onSubmit)}>
              {currentStep === 1 && (
                <GsaPdfModal show={isPDFOpen.show} setShow={setIsPDFOpen} />
              )}

              {currentStep === 1 && (
                <GeneralInformation
                  isEditing={isEditing}
                  orderMade={isOrderMade}
                />
              )}
              {currentStep === 2 && (
                <PaymentAndShippingForm initialVal={initialVal} />
              )}
              {currentStep === 3 && <OtherDetailsForm isEditing={rfq_id} />}
              {/* {currentStep === 4 && (
                <FinanceTab
                  apiVendor={apiVendor}
                  orderId={rfq_id}
                  onRefresh={refreshOrder}
                /> 
              )} */}
              {currentStep === 4 && (
                <Attachment attachmnetid={formId} status={rfqstatus} />
              )}
              {currentStep === 5 && <ContactDetailsForm status={rfqstatus} />}
              {currentStep === 6 && <SalesLead />}

              <div className="server_error">
                {show && (
                  <>
                    <Alert
                      variant="danger"
                      onClose={() => setShow(false)}
                      dismissible
                    >
                      <Alert.Heading>Validation Errors!</Alert.Heading>
                      {Object.keys(serverErr).map((field) => (
                        <p
                          key={field}
                          style={{ color: "red", marginBottom: "5px" }}
                        >
                          {serverErr[field]?.message}
                        </p>
                      ))}
                    </Alert>
                  </>
                )}
              </div>

              <div className="d-flex justify-content-center gap-3 mt-3">
                {currentStep > 1 && (
                  <Button
                    variant="outline-secondary"
                    onClick={() => handleStepChange("prev")}
                  >
                    <IconArrowNarrowLeftDashed /> Back
                  </Button>
                )}
                {rfq_id
                  ? currentStep < 6 && (
                      <Button
                        variant="warning"
                        onClick={() => handleStepChange("next")}
                      >
                        Next <IconArrowNarrowRightDashed />
                      </Button>
                    )
                  : currentStep < 6 && (
                      <Button
                        variant="warning"
                        onClick={() => handleStepChange("next")}
                      >
                        Next <IconArrowNarrowRightDashed />
                      </Button>
                    )}

                {rfq_id
                  ? currentStep < steps.length &&
                    canShowButtons && (
                      <div className="d-flex">
                        <Button variant="success" type="submit">
                          {createLoading || UpdateLoading ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Update"
                          )}
                        </Button>
                      </div>
                    )
                  : null}

                {rfq_id
                  ? currentStep === 6 &&
                    canShowButtons && (
                      // !["WON", "LOST", "CANCELLED"].includes(rfqstatus) && (
                      <div className="d-flex">
                        <Button
                          variant="warning"
                          type="submit"
                          disabled={createLoading || UpdateLoading}
                        >
                          {createLoading || UpdateLoading ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </div>
                    )
                  : currentStep === 6 && (
                      <div className="d-flex">
                        <Button
                          variant="warning"
                          type="submit"
                          disabled={createLoading || UpdateLoading}
                        >
                          {createLoading || UpdateLoading ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </div>
                    )}
                {currentStep === 6 && !rfq_id && (
                  <div className="d-flex">
                    <Button
                      className="flex-grow-1"
                      variant="outline-secondary"
                      disabled={createLoading || UpdateLoading}
                      onClick={() => {
                        methods.handleSubmit((data) =>
                          onSubmit(data, { force_status: "DRAFT" }),
                        )();
                      }}
                      // onClick={() => {
                      //   setRfqStatus("DRAFT");
                      //   methods.handleSubmit(onSubmit)();
                      // }}
                    >
                      {createLoading || UpdateLoading ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Save as Draft"
                      )}
                    </Button>
                  </div>
                )}
              </div>
            </Form>
          </FormProvider>
        </Card.Body>
      </Card>
    </>
  );
}

export default NewQuote;
